import React, { useEffect, useState } from "react";

import { Dropdown, Card, Box, ToggleSwitch, Button, Text } from "@wix/design-system";
import * as Icons from "@wix/wix-ui-icons-common";
import { useForm, Controller } from "react-hook-form";
import { showToast } from "@wix/dashboard-sdk";

import Setting from "../../../models/setting";
import Loading from "../../common/Loader";

const OrderSettings: React.FC<any> = ({ context = "settings", onSuccess = () => {} }) => {
  const defaultValues = {
    sync_orders_to_wix: false,
    sync_order_status_to_faire: false,
    sync_commission_as: false,
    customer_display_name: "company-name",
  };

  const { handleSubmit, control, reset } = useForm({
    defaultValues: {
      ...defaultValues,
    },
  });

  /*
  |--------------------------------------------------------------------------
  | States
  |--------------------------------------------------------------------------
  |
  */
  const [isLoading, setLoading] = useState(false);
  const [status, setStatus] = useState(false);

  /*
  |--------------------------------------------------------------------------
  | Get Order Settings
  |--------------------------------------------------------------------------
  |
  */
  const fetchOrderSettings = () => {
    Setting.getOrder()
      .then((response) => {
        const settingData = {
          sync_orders_to_wix: response.data.sync_orders_to_wix === 0 ? false : true,
          sync_commission_as: response.data.sync_commission_as === "product-price" ? false : true,
          sync_order_status_to_faire: response.data.sync_order_status_to_faire === 0 ? false : true,
          customer_display_name: response.data.customer_display_name,
        };

        reset({
          ...defaultValues,
          ...settingData,
        });
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    fetchOrderSettings();
  }, [status]);

  /*
  |--------------------------------------------------------------------------
  | Order Setting Submit
  |--------------------------------------------------------------------------
  |
  */
  const onSubmit = (data: any) => {
    data.sync_commission_as === false
      ? (data.sync_commission_as = "product-price")
      : (data.sync_commission_as = "order-price");

    setLoading(true);
    Setting.setOrder(data)
      .then((response) => {
        setStatus(true);
        showToast({
          type: "success",
          message: "Your Settings have been Saved",
        });
        setLoading(false);
        onSuccess();
      })

      .catch((error) => {
        console.error(error);
        setStatus(false);
        showToast({
          type: "error",
          message: "Failed To Save Settings",
        });
        setLoading(false);
      });
  };

  return (
    <div style={{ width: "100%" }}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div style={{ marginBottom: "24px" }}>
          <Card>
            {context === "settings" && (
              <>
                <Card.Header title="Order Settings" />
                <Card.Divider />
              </>
            )}
            <Box verticalAlign="middle" align="space-between" padding="18px 24px">
              <Box direction="vertical">
                <Text weight="bold" skin="standard">
                  Order Import
                </Text>
                <Text secondary size="small">
                  Sync the orders from Faire to Wix based on matching SKU.
                </Text>
              </Box>
              <Controller
                name="sync_orders_to_wix"
                control={control}
                render={({ field: { value, onChange } }) => <ToggleSwitch checked={value} onChange={onChange} />}
              />
            </Box>
            <Card.Divider />
            <Box verticalAlign="middle" align="space-between" padding="18px 24px">
              <Box direction="vertical">
                <Text weight="bold" skin="standard">
                  Order Status Sync
                </Text>
                <Text secondary size="small">
                  Sync the order fulfillment status from Wix to Faire.
                </Text>
              </Box>
              <Controller
                name="sync_order_status_to_faire"
                control={control}
                render={({ field: { value, onChange } }) => <ToggleSwitch checked={value} onChange={onChange} />}
              />
            </Box>
            {/* <Card.Divider />
            <Box verticalAlign="middle" align="space-between" padding="18px 24px">
              <Box direction="vertical">
                <Text weight="bold" skin="standard">
                  Order Commission
                </Text>
                <Text secondary size="small">
                  Include Commission amount in order while exporting order to Wix.
                </Text>
              </Box>
              <Controller
                name="sync_commission_as"
                control={control}
                render={({ field: { value, onChange } }) => <ToggleSwitch checked={value} onChange={onChange} />}
              />
            </Box> */}
            <Card.Divider />
            <Box verticalAlign="middle" align="space-between" padding="18px 24px">
              <Box direction="vertical">
                <Text weight="bold" skin="standard">
                  Order Client Name
                </Text>
                <Text secondary size="small">
                  Use customer name while showing customer detail in Wix.
                </Text>
                <Text size="tiny" skin="primary">
                  By default company name is used instead of customer name.
                </Text>
              </Box>
              <Controller
                name="customer_display_name"
                control={control}
                render={({ field: { value, onChange } }) => (
                  <Dropdown
                    size="large"
                    options={[
                      { id: "company-name", value: "Company name" },
                      { id: "customer-name", value: "Customer name" },
                    ]}
                    selectedId={value}
                    onSelect={(selectedOption: any) => onChange(selectedOption.id)}
                  />
                )}
              />
            </Box>
          </Card>
        </div>

        <Button
          type="submit"
          size="medium"
          prefixIcon={isLoading ? <Loading size="tiny" /> : context === "settings" ? <Icons.Download /> : ""}
          suffixIcon={!isLoading && context !== "settings" ? <Icons.ArrowRight /> : ""}
        >
          {context === "settings" ? "Save configurations" : "Save and Continue"}
        </Button>
      </form>
    </div>
  );
};

export default OrderSettings;
